import styled from 'styled-components';
import { ty } from '@client/styles/typography';

export const TermsText = styled.p.attrs({
  className: ty('paragraph400', 'secondary'),
})`
  text-align: center;
  margin-bottom: 24px;
`;
